<script setup lang="ts">
import { PropType } from 'vue';
import MyButtonBase from './MyButtonBase.vue';
import { IonIcon, IonBadge, IonSpinner } from '@ionic/vue';

defineProps({
  label: { type: String, required: true },
  icon: String,
  iconSlot: { type: String as PropType<'start' | 'end'>, default: 'start' },
  badgeText: String,
  badgeSlot: { type: String as PropType<'start' | 'end'>, default: 'end' },
  badgeColor: { type: String, default: 'primary' },
  showSpinner: { type: Boolean, default: false },
  spinnerSlot: { type: String as PropType<'start' | 'end'>, default: 'start' },
});
</script>

<template>
  <my-button-base>
    <ion-spinner
      v-if="showSpinner"
      :slot="spinnerSlot"
      class="ion-margin-horizontal"
    ></ion-spinner>

    <ion-icon
      v-if="icon"
      class="icon-class"
      :slot="iconSlot"
      :icon="icon"
    ></ion-icon>
    <div :class="{ labelIconClass: icon, labelOnlyClass: !icon }">
      {{ label }}
    </div>
    <ion-badge v-if="badgeText" :slot="badgeSlot" :color="badgeColor">{{
      badgeText
    }}</ion-badge>
  </my-button-base>
</template>

<style scoped>
.label-only-class {
  padding-left: 10px;
  padding-right: 10px;
}

.icon-class {
  padding-left: 10px;
}
.label-icon-class {
  padding-right: 10px;
}

ion-badge {
  border-radius: 10px;
}
</style>
